import * as React from 'react';
const AccordionHeaderContext = React.createContext(undefined);
const accordionHeaderContextDefaultValue = {
    open: false,
    disabled: false,
    size: 'medium',
    expandIconPosition: 'start'
};
export const { Provider: AccordionHeaderProvider } = AccordionHeaderContext;
var _React_useContext;
export const useAccordionHeaderContext_unstable = ()=>(_React_useContext = React.useContext(AccordionHeaderContext)) !== null && _React_useContext !== void 0 ? _React_useContext : accordionHeaderContextDefaultValue;
